import { handleSessionLessApi } from '../../common';

const API_ENDPOINTS = {
	localIndices: `flash/indices/indian/filtered`,
	globalIndices: `flash/indices/global/all`,
};

export const fetch_global_indices_v2 = async (Api, sessionLessServer = '') => {
	const fetchUrl = `${sessionLessServer}${API_ENDPOINTS.globalIndices}`;
	const response = await Api.get(fetchUrl);
	const result = handleSessionLessApi(response);
	return result;
};
export const fetch_indian_indices_v2 = async (Api, sessionLessServer) => {
	const fetchUrl = `${sessionLessServer}${API_ENDPOINTS.localIndices}`;
	const response = await Api.get(fetchUrl);
	const result = handleSessionLessApi(response);
	return result;
};
